<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-29 12:47:43
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-14 21:09:56
-->
<template>
  <div class="footer-wrapper">
    <div @click="handleLinkEdit" class="add-question">
      <img src="../assets/edit-icon.png" class="edit-icon" alt="">
      <!-- <div class="edit-icon"> -->
        <!-- <van-icon name="edit" size="26" /> -->
      <!-- </div> -->
    </div>
    <div class="bottom van-hairline--top">
      <div
        v-for="item in bottomTabList"
        :key="item.id"
        @click="handleBottomTabChange(item.id)"
        :style="activeTab === item.id ? {color:'#3477E9'} : ''"
        class="operate-item">
        <!-- <svg v-show="activeTab === item.id && item.id !== 1" class="icon" aria-hidden="true">
          <use :xlink:href="'#icon-' + item.icon"></use>
        </svg> -->
        <template v-if="item.id === 1">
          <van-badge>
            <template #content>
              <span>new</span>
            </template>
            <img v-show="activeTab === item.id" :src="require('../assets/' + item.icon + '.png')" class="icon" alt="">
            <img v-show="activeTab !== item.id" :src="require('../assets/' + item.icon + 'Default.png')" class="icon" alt="">
          </van-badge>
        </template>
        <template v-else>
          <img v-show="activeTab === item.id" :src="require('../assets/' + item.icon + '.png')" class="icon" alt="">
          <img v-show="activeTab !== item.id" :src="require('../assets/' + item.icon + 'Default.png')" class="icon" alt="">
        </template>
        <span>{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {
    activeTab: {
      type: Number,
      default: 0
    },
    deptActive: {
      type: [Number,String],
      default: -1
    }
  },
  data() {
    return {
      bottomTabList: [
        { id: 0, name: '文章', icon: 'shouye', size: 22 },
        { id: 1, name: '畅聊', icon: 'wenda', size: 26 },
        { id: 2, name: '我的', icon: 'wode', size: 22 }
      ],
    }
  },
  computed: {
    // ...mapState(['activeTab'])
    // activeTab() {
    //   if (this.$route.name === 'mine') {
    //     return 2
    //   }
    //   return +this.$route.query?.type || 0
    // }
  },
  activated() {
    const type = +this.$route.query.type
    const refresh = +this.$route.query.refresh
    if (refresh) {
      this.handleBottomTabChange(type)
    }
  },
  methods: {
    ...mapMutations(['updateTab']),
    handleBottomTabChange(val) {
      if (val < 2) {
        if (this.$route.name === 'mine' || this.$route.name === 'personal') {
          this.$router.replace({ name: 'articleList', query: { type: val, refresh: 1 }})
        } else {
          this.$emit('tabChange', val)
        }
      } else {
        this.$router.push({ name: 'mine' })
      }
    },
    handleLinkEdit() {
      const query = {};
      if (this.activeTab === 1) {
        query.deptActive = this.deptActive;
      }
      this.$router.push({ name: 'release', query })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-badge--fixed {
  top: -2px;
  right: -10px;
}
/deep/ .van-badge {
  border: none;
  line-height: inherit;
}
.footer-wrapper {
  position: fixed;
  bottom: 0;
  background: #fff;
  height: 64px;
  width: 100%;
  display: flex;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .bottom {
    display: flex;
    flex: 1;
    color: #646566;
    .operate-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      > span {
        font-size: 12px;
      }
    }
  }
  .icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    overflow: hidden;
    margin-bottom: 2px;
  }
  .icon-wenda2:before {
    content: "\fe0a";
  }
  .add-question {
    position: fixed;
    right: 5px;
    bottom: 120px;
    width: 56px;
    height: 56px;
    color: #fff;
    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
  }
  .edit-icon {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
  }
}
</style>
